module.exports = __webpack_public_path__ + "media/images/products/retailers-customised-7-sample04-55809f03f8d7802bb3072df0218f273e.jpg";